import { useMsal } from "@azure/msal-react";
import { enviroment } from "../enviroment";
import { collectEmails } from "./useIsApiKeyAdmin";

/**
 * "Today's orders" (/admin/orders-today) for the named admins only. The
 * allow-list lives in REACT_APP_ORDERS_TODAY_ADMIN_EMAILS (comma-separated,
 * parsed by parseOptionalEmailAllowlist): UNSET = every admin, exactly
 * today's menu and route; set without a single address = nobody. Reads the
 * MSAL account's e-mails like useIsApiKeyAdmin (collectEmails). The API
 * decides with its own StatsOrdersTodayAdminEmails - this hook only hides
 * the menu item and the route.
 */
export function useIsOrdersTodayAdmin(): boolean {
  const { accounts } = useMsal();
  const allowed = enviroment.ordersTodayAdminEmails;
  if (allowed == null) return true;
  const account = accounts[0];
  if (!account) return false;
  return isOrdersTodayAllowed(allowed, collectEmails(account));
}

export function isOrdersTodayAllowed(
  allowed: readonly string[] | null | undefined,
  emails: readonly string[],
): boolean {
  if (allowed == null) return true;
  return emails.some((e) => allowed.includes(e));
}
